import React from 'react';
import { Link as GatsbyLink } from 'gatsby-plugin-react-intl';

const Link = ({ children, to, activeClassName, partiallyActive, ...other }) => {
  const internal = /^\/(?!\/)/.test(to);

  if (internal) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }

  return (
    <a href={to} {...other} target="_blank">
      {children}
    </a>
  );
};

export default Link;
